export const ADVERTISING_ID_QUERY_PARAM: string = 'advertising_id';

export const ADVERTISING_ID_COOKIE: string = 'advertising_id';
